import type { LiveCollection } from './use-live-collection';

const NO_ROWS: never[] = [];

/**
 * The one rule for which rows a live collection shows. Baked rows are used only for `static`,
 * where a live fetch is impossible. `loading` and `failed` never fall back to baked rows.
 */
export function liveCollectionRows<T>(live: LiveCollection<T>, baked: unknown): T[] {
  switch (live.status) {
    case 'ready':
      return live.rows;
    case 'failed':
      return live.lastRows ?? NO_ROWS;
    case 'loading':
      return NO_ROWS;
    case 'static':
      return Array.isArray(baked) ? baked as T[] : NO_ROWS;
    default: {
      const unhandled: never = live;
      return unhandled;
    }
  }
}
